export default function OpenedDoorIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 113 200" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#opened-door-icon)">
          <path d="m79.027 9.7067v-8.7371c0-0.64491-0.612-1.1104-1.2296-0.93652l-33.699 9.668h-43.135c-0.53412 0-0.96252 0.43744-0.96252 0.97014v168.94c0 0.538 0.43397 0.97 0.96252 0.97h8.4791v-0.236l0.80669 0.236 67.549 19.375c0.6176 0.174 1.2296-0.291 1.2296-0.936v-18.445h32.714c0.535 0 0.963-0.437 0.963-0.97v-168.93c0-0.5383-0.434-0.97014-0.963-0.97014h-32.714zm-69.585 10.672v158.27h-7.5166v-167h35.407l-27.195 7.8006c-0.41174 0.1177-0.70106 0.4991-0.70106 0.9365l0.00557-0.0056zm67.66 177.37-59.782-17.166-5.9532-1.711v-157.75l5.9532-1.7104 27.051-7.7669 6.76-1.9403 25.971-7.4585v195.5zm1.9251-19.106v-157.29h21.459v157.29h-21.459zm31.746 0h-8.362v-158.26c0-0.5384-0.434-0.9702-0.962-0.9702h-22.422v-7.7669h31.746v167z"/>
          <path d="m9.4416 180.35v0.235h0.80675l-0.80675-0.235z"/>
          <path d="m62.035 104.38c2.3046 0 4.1728-1.883 4.1728-4.205 0-2.3233-1.8682-4.2064-4.1728-4.2064-2.3045 0-4.1728 1.8831-4.1728 4.2064 0 2.322 1.8683 4.205 4.1728 4.205z"/>
        </g>

        <defs>
          <clipPath id="opened-door-icon">
            <rect width="112.7" height="200"/>
          </clipPath>
        </defs>
      </svg>
    </>
  );
}